// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import store from './vuex/store'
import * as filters from './util/filter'

import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/dataZoom'

Object.keys(filters).forEach(k => Vue.filter(k, filters[k])) //注册过滤器

Vue.use(MintUI)
Vue.component('chart', ECharts)

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  store,
  ...App
})
export default vue


// WEBPACK FOOTER //
// ./src/main.js